module.exports = __webpack_public_path__ + "static/28-5da64ad6b0d40f51f03a9ee4f3d87707.jpg";